// extracted by mini-css-extract-plugin
export default {"container":"zq-z","ratingLayout":"Aq-z","ratingLabel":"Bq-z","nonInteractiveRatingLabel":"Cq-z"};